import { plugin, type ConfirmProps } from 'light-component';
import { Modal } from 'antd';
import { t } from '../../i18n';
import type { ReactElement } from 'react';

export function WidgetModal(props: ConfirmProps): ReactElement {
  return (
    <Modal
      title={t(props.title ?? '警告')}
      open={props.open}
      onOk={props.onOk}
      onCancel={props.onCancel}
      okText={props.okText != null ? t(props.okText) : undefined}
      cancelText={props.cancelText != null ? t(props.cancelText) : undefined}
    >
      {t(props.message)}
    </Modal>
  );
}

plugin.register({ kind: 'widget', type: 'modal', component: WidgetModal });
